export const ButtonOptionsFormProp = Object.freeze({
    Title: 'title',
    FieldGroups: 'fieldGroups',
});